<div>
  <mat-toolbar>
    <h2>New Item Process</h2>
  </mat-toolbar>
  <mat-dialog-content>
    <form [formGroup]="quoteDetailsForm">
      <div class="flex gap-4">
        <mat-form-field class="w-full">
          <mat-label>Category</mat-label>
          <mat-select formControlName="itemType">
            @for (option of itemProcessesCategories(); track option.key) {
              <mat-option [value]="option.key">{{ option.value }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>Unique Id</mat-label>
          <input
            matInput
            cdkFocusInitial
            formControlName="uniqueId"
            [matAutocomplete]="auto"
            (click)="
              quoteDetailsForm
                .get('uniqueId')
                ?.setValue(quoteDetailsForm.get('uniqueId')?.value || '')
            "
          />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            @for (item of filteredOptions$ | async; track item.id) {
              <mat-option [value]="item">{{ item['itemId'] }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>

      @if (itemProcessesLoading()) {
        <div class="flex justify-center items-center p-8">
          <mat-spinner></mat-spinner>
        </div>
      } @else {
        @if (quoteDetailsForm.get('itemType')?.value) {
          <div class="mt-4 grid grid-cols-2 gap-4">
            <mat-form-field class="w-full">
              <mat-label>Description</mat-label>
              <input matInput formControlName="description" placeholder="Enter description" />
            </mat-form-field>

            @if (quoteDetailsForm.get('itemType')?.value === 'OTHER') {
              <mat-form-field class="w-full">
                <mat-label>Base Price/Unit</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="pricePerUnit"
                  placeholder="Enter base price per unit"
                />
              </mat-form-field>
            }

            @if (quoteDetailsForm.get('itemType')?.value === 'COPPER') {
              <mat-form-field class="w-full">
                <mat-label>LBs/1000ft</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="lbPer1000ft"
                  placeholder="Enter LBs per 1000ft"
                />
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>Surcharge</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="pricePerLb"
                  placeholder="Enter surcharge"
                />
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>Base Price</mat-label>
                <input matInput formControlName="basePrice" readonly />
              </mat-form-field>
            }

            @if (quoteDetailsForm.get('itemType')?.value === 'SINGLE_END') {
              <mat-form-field class="w-full">
                <mat-label>Specific Gravity</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="specificGravity"
                  placeholder="Enter specific gravity"
                />
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>Constant 1</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="constant1"
                  placeholder="Enter constant 1"
                />
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>Surcharge</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="pricePerLb"
                  placeholder="Enter surcharge"
                />
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>Base Price</mat-label>
                <input matInput formControlName="basePrice" readonly />
              </mat-form-field>
            }

            @if (
              quoteDetailsForm.get('itemType')?.value === 'COMPOUNDS' ||
              quoteDetailsForm.get('itemType')?.value === 'TEFLON_TAPES'
            ) {
              <mat-form-field class="w-full">
                <mat-label>Specific Gravity</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="specificGravity"
                  placeholder="Enter specific gravity"
                />
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>Base Price/LB</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="pricePerLb"
                  placeholder="Enter base price per LB"
                />
              </mat-form-field>
            }

            @if (quoteDetailsForm.get('itemType')?.value === 'ALL_TAPES_AND_FILLERS') {
              <mat-form-field class="w-full">
                <mat-label>Specific Gravity</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="specificGravity"
                  placeholder="Enter specific gravity"
                />
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>Constant 1</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="constant1"
                  placeholder="Enter constant 1"
                />
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>Constant 2</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="constant2"
                  placeholder="Enter constant 2"
                />
              </mat-form-field>
              <mat-form-field class="w-full">
                <mat-label>Base Price/LB</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="pricePerLb"
                  placeholder="Enter base price per LB"
                />
              </mat-form-field>
            }
          </div>
        }
      }
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button type="button" (click)="onCancel()">Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="!quoteDetailsForm.valid"
      (click)="onSubmit()"
    >
      Add to Quote
    </button>
  </mat-dialog-actions>
</div>
